export default {
  props: {
    src: {
      type: String,
      required: true,
    },

    alt: {
      type: String,
    },

    longdesc: {
      type: String,
    },

    title: {
      type: String,
    },

    transparent: {
      type: Boolean,
      default: false,
    },

    withoutLazyload: {
      type: Boolean,
      default: false,
    },

    aspectRatio: {
      type: String,
      default: '',
    },

    srcsetDesktop: {
      type: String,
    },

    srcsetDesktopWebp: {
      type: String,
    },

    srcsetTablet: {
      type: String,
    },

    srcsetTabletWebp: {
      type: String,
    },

    srcsetMobile: {
      type: String,
    },

    srcsetMobileWebp: {
      type: String,
    },

    width: {
      type: String,
    },

    height: {
      type: String,
    },
  },

  computed: {
    transparentClasses() {
      if (this.transparent) return 'image--transparent'
    },

    aspectRatioClasses() {
      if (this.aspectRatio) return `aspect-ratio--${this.aspectRatio}`
    },
  },
}
